import axios from 'axios'
import * as vars from './vars';
import {getTimezone} from 'Utils/time'

export function requestMeeting (request, jwt) {
    const data = request;
    data['timezone'] = getTimezone()
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/scheduling/ProposeNewMeeting',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
  }

    export function confirmMeeting (data, jwt){
        return axios({
            method: 'POST',
            url: vars.baseURL + '/api/v3/scheduling/AcceptMeetingProposal',
            headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
            data: data
        })
      }

    export function cancelMeeting (meetingId, reason, jwt) {
        return axios({
            method: 'POST',
            url: vars.baseURL + '/api/v3/scheduling/CancelMeeting',
            headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
            data: {
                meetingId: meetingId,
                timezone: getTimezone(),
                reason: reason
            }
        })
      }

    export function joinMeeting (meetingId, ip, jwt) {
        return axios({
            method: 'POST',
            url: vars.baseURL + '/api/v3/meetings/JoinMeeting',
            headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
            data: {
                meetingId: meetingId,
                ip: ip
            }
        })
      }

    export function leaveMeeting (meetingId, jwt) {
        return axios({
            method: 'POST',
            url: vars.baseURL + '/api/v3/meetings/LeaveMeeting',
            headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
            data: {
                meetingId: meetingId
            }
        })
    }

    export function checkMeetingAvailability (date, timezone, duration, jwt) {
        return axios({
          method: 'POST',
          url: vars.baseURL + '/api/v3/scheduling/FetchUserAvailableMeetingTimes',
          headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
          data: {
              date: date, timezone: timezone, duration: duration
          }
        })
      }

    export function getUserMeetings (jwt) {
      return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/meetings/FetchAllMeetings',
        headers: { api_key: vars.apiKey, 'Authorization': `Bearer ${jwt}`},
        data: {}
      })
    }

    export function getMeetingById (meetingId, jwt) {
      return axios({
          method: 'POST',
          url: vars.baseURL + '/api/v3/scheduling/GetMeeting',
          headers: { api_key: vars.apiKey, 'Authorization': `Bearer ${jwt}`},
          data: {
              meetingId: meetingId
          }
      })
  }


